import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { NotificationPayload } from 'src/models/NotificationModel';

export const getNotificationsData =
  (organisation: string) => makeApiRequest({
    method: 'GET',
    url: API_URL.notifications,
    organisation,
  });

export const postNotificationData =
  (organisation: string, payload: NotificationPayload) => makeApiRequest({
    method: 'POST',
    url: API_URL.notification,
    organisation,
    data: {
      type: payload.type,
      contacts: payload.contacts,
    },
  });

export const putNotificationData =
  (organisation: string, payload: NotificationPayload) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.notification}/${payload.id}`,
    organisation,
    data: {
      type: payload.type,
      contacts: payload.contacts,
    },
  });
